import 'bootstrap'

$(() => {
  const scope = $('.navbar').find('.dropdown, .collapse')
  const hamburgers = $('.navbar .hamburger')
  scope.on('show.bs.dropdown show.bs.collapse', event => hamburgers.addClass('is-active'))
  scope.on('hide.bs.dropdown hide.bs.collapse', event => hamburgers.removeClass('is-active'))
})
